import { Modal } from '@/components/modal';
import { Button } from '@/components/ui/button';

interface IdleTimeoutModalProps {
  open: boolean;
  secondsLeft: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export function IdleTimeoutModal({
  open,
  secondsLeft,
  onStayLoggedIn,
  onLogout,
}: IdleTimeoutModalProps) {
  return (
    <Modal
      isDialogOpen={open}
      title='Still there?'
      description={`You'll be logged out due to inactivity in ${secondsLeft} second${
        secondsLeft === 1 ? '' : 's'
      }.`}
      hideCloseButton
      preventClose
      footer={
        <div className='flex justify-end gap-2'>
          <Button variant='outline' onClick={onLogout}>
            Log out now
          </Button>
          <Button onClick={onStayLoggedIn}>Stay logged in</Button>
        </div>
      }
    />
  );
}
